export default __webpack_public_path__ + "static/media/MyKaizenSMART.c5a0e24a139c83a71b6231a282d95098.webp";